import $ from "jquery";
import * as THREE from "three";
import {
  ChangeGlobalMorph,
  GetMesh,
  hideIcon,
  mapForWood,
  materialSolid,
  pergola,
  pergolaConst,
  setAllHotspotsVisibility,
  showIcon,
  toggleBackWall,
  toggleLeftWall,
  toggleRightWall,
} from "../../../../../core/3d-configurator";
import {
  removeFromUrlSystemBySide,
  removeFromUrlSystemByType,
} from "../../../../../core/customFunctions/initiSubSystem";
import {
  state,
  villaPergolaPreset,
  weatherproofPreset,
} from "../../../../../core/settings";
import {
  groups,
  stringEndCuts,
  stringPostType,
  stringRoofType,
  stringTypeModel,
  stringTypePegola,
} from "../../../interface";
import "./interfaceGroupInputs.scss";
import {
  generateRangeHTML,
  getRangesFromState,
  updateRangeLabelsFromState,
} from "./range/generateRange";
import { countActiveSystemsInPergola } from "../../../../summary/summary-page/summaryPage";

export const colors = {
  White: "#1C1C1C",
  Grey: "#F5F5F5",
  Gray: "#B0B0B0",
  Coffee: "#36454F",
  Oak: "#3F1A00",
};

export const typesInputs = {
  modelType: "model",
  // selectButton: "select",
  mountedType: "mountedType",
  range: "button",
  postSize: "post-size",
  colorsButton: "colorsButton",
  electronic: "electro",
  subSystem: "system",
  roofForLite: "liteRoof",
  typePergola: "typePergola",
  roofType: "roofTypes",
  endCuts: "endCuts",
};

export let stringNameRoofLetticeColor = null;
export let stringNameRoofSolidColor = null;
export let stringNameFrameColor = null;

export const typeSubSystem = {
  "Motorized Zip Screen": "Motorized Zip Screen",
  "Sliding Glass Door": "Sliding Glass Door",
  "Bi-folding Glass Door": "Bi-folding Glass Door",
  "Fixed Shutters": "Fixed Shutters",
  "Sliding Shutters": "Sliding Shutters",
  "Bi-Ffolding Shutters": "Bi-Ffolding Shutters",
  "Fixed Slats": "Fixed Slats",
};

export const wallAddOptionString = {
  0: "Back Wall",
  1: "Left Wall",
  2: "Right Wall",
};

export function applyPergolaModelSettingsPreset(preset) {
  state.colorsRoof = preset.colorRoofs;
  state.colorsFrame = preset.colorFrames;
  state.modelType = preset.name;
  state.lightOnLouvers = preset.lightOnLouvers;
  state.maxHeight = preset.maxHeight;
  state.maxWidth = preset.maxWidth;
  state.maxLength = preset.maxLength;

  const $ledLouversElement = $(
    ".type_interface_electronic_item.option.ledLouvers_item"
  );
  if (state.lightOnLouvers) {
    $ledLouversElement.show();
  } else {
    $ledLouversElement.hide();
  }
}

export function updateTextParam(
  customSetting,
  context,
  electro = false,
  onlyText = false,
  subSystem = false,
  walls = false
) {
  const text = [];

  if (!electro) {
    if (customSetting.backWall && walls) {
      text.push("Back Wall");
    }
    if (customSetting.leftWall && walls) {
      text.push("Left Wall");
    }
    if (customSetting.rightWall && walls) {
      text.push("Right Wall");
    }
    if (
      !customSetting.rightWall &&
      !customSetting.leftWall &&
      !customSetting.backWall &&
      !subSystem &&
      walls
    ) {
      text.push("Freestanding");
    }
  }
  if (subSystem) {
    customSetting.subSystem.forEach((option) => text.push(option));
  }
  if (electro) {
    customSetting.electro.forEach((option) => {
      text.push(option);
    });
  }

  let displayText = "";

  if (text.length > 1) {
    displayText = text.join(", ");
    if (displayText.length > 15) {
      displayText = displayText.substring(0, 12) + "...";
    }
  } else {
    displayText = text.length === 1 ? text[0] : "-";
  }
  if (onlyText) {
    return displayText;
  }

  $(context)
    .closest(".interface__group")
    .find(".interface__group__head__param")
    .text(displayText);
}

export function updateMaterialMap(mesh, hex = false) {
  if (mesh?.material) {
    const isWood = hex === "#FFFFFF" || hex === "#A0522D";

    console.log(isWood, hex, "COLOR CHNAGED");

    if (isWood) {
      console.log("COLOR IS TEXTURE", mapForWood);

      mesh.material.map = mapForWood;
      mesh.material.color.set(0xffffff);
      mesh.material.needsUpdate = true;
    } else {
      mesh.material.map = null;
      mesh.material.baseColor = null;
      mesh.material.color.set(hex);
      mesh.material.needsUpdate = true;
      mesh.material.normalMap = null;
    }
  }
}

export function updateInterfaceHeaderText() {
  groups.forEach((group) => {
    // Find the interface group in the DOM
    const $interfaceGroup = $(".interface__group").filter(function () {
      return (
        $(this).find(".interface__group__head__title").text().trim() ===
        group.title
      );
    });

    if ($interfaceGroup.length > 0) {
      // Calculate current param value
      const currentParamText =
        typeof group.param === "function" ? group.param() : group.param;

      // Update the header param
      $interfaceGroup
        .find(".interface__group__head__param")
        .text(currentParamText);
    }
  });
}

export function interfaceGroupInputsComponent(
  type,
  ranges,
  initValue = false,
  title
) {
  switch (type) {
    case typesInputs.modelType:
      // Dynamically map all Model types, their pictures and labels
      const radioModelInputs = $(`  
    <form class="type_interface_radio-model">
      ${Object.entries(stringTypeModel)
        .map(([value, labelText]) => {
          const id = labelText.toLowerCase().replace(/\s+/g, "");
          const classSafeId = stringTypeModel[value]
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, "-")
            .replace(/^-+|-+$/g, ""); //for Villa Pergola 2.0 case - to replace dot and spaces
          return `
            <div class="type_interface_radio-model_item option">
              <input data-value="${value}" 
                     class="type_interface_radio-model_option type_interface_radio-model_option--${classSafeId}"
                     type="radio" id="${id}" name="fav_language" value="${id}">
              <label class="type_interface_radio-model_label" for="${id}">${labelText}</label>
            </div>`;
        })
        .join("")}
    </form>`);

      const activeModelClass = "active";
      const villaPergola = radioModelInputs.find(".option").eq(0);
      const weatherproof = radioModelInputs.find(".option").eq(1);

      // HANDLE TYPE BUTTONS
      villaPergola.on("click", function () {
        $("#gold-bar").show();

        state.typeSlideGlass = true; 

        // SET DEFAULT IF ITS NOT EXIST COLOR
        if (state.colorBody === "#A0522D" || state.colorBody === "#808C93") {
          state.colorBody = "#1C1C1C";
          state.selectedFrameColorName = "Black";
        }

        if (state.colorRoof == "#808C93") {
          state.selectedRoofColorName = "Black";
          state.colorRoof = "#1C1C1C";
        }


        applyPergolaModelSettingsPreset(villaPergolaPreset);
        updateColorSections();
        updateRangeLabelsFromState();
        pergola.update();
      });

      weatherproof.on("click", function () {
        $("#gold-bar").hide();

        applyPergolaModelSettingsPreset(weatherproofPreset);
        updateColorSections();
        updateRangeLabelsFromState();
        pergola.update();
      });

      // INIT
      setTimeout(() => {
        if (state.type3Dmodel) {
          weatherproof.trigger("click");
        } else {
          villaPergola.trigger("click");
        }
      }, 1000);

      radioModelInputs
        .find('.type_interface_radio-model_item input[type="radio"]')
        .each(function () {
          const radioButton = $(this);
          const type = +$(this).attr("data-value");

          if (state.type3Dmodel === type) {
            radioButton
              .closest(".type_interface_radio-model_item")
              .addClass(activeModelClass);
          }
        });

      //#region HANDLE MODEL
      radioModelInputs
        .find('.type_interface_radio-model_item input[type="radio"]')
        .on("change", function () {
          // CHANGE STATE

          state.type3Dmodel = +$(this).attr("data-value");

          const parentItem = $(this).closest(
            ".type_interface_radio-model_item"
          );
          // updateRoofInputs(roofGroup);
          updateUIAfterModelChange(parentItem);
          // updatePostSize();

          state.width = 10;
          state.length = 10;
          state.height = 8;

          $(`#range__input-width`).val(`${state.width}`).trigger("input");
          $(`#range__input-length`).val(`${state.length}`).trigger("input");
          $(`#range__input-height`).val(`${state.height}`).trigger("input");

          pergola.update();
          pergola.checkSystemsInScene();
        });

      //#region ROOF PARAMS
      function createRoofGroup() {
        return {
          title: "Roof",
          ranges: [
            {
              title: "Rotation",
              min: 0,
              max: 120,
              step: 1,
              thumb: false,
              initialValue: state.currentRotationZ,
              showLabels: true,
              showSwitchAngle: true,
            },
          ],
        };
      }
      //#endregion

      //#region ADD ROOF GROUP
      function updateRoofInputs(roofGroup) {
        const inputsRoof = $($(".interface__group")[2]).find(
          ".interface__group__inputs"
        );
        const newInputs = interfaceGroupInputsComponent(
          roofGroup.type,
          roofGroup.ranges,
          roofGroup.initValuePostSize,
          roofGroup.title
        );

        inputsRoof
          .closest(".interface__group")
          .find(".interface__group__head__param")
          .text(roofGroup.param);

        inputsRoof.empty();
        inputsRoof.append(newInputs);
      }
      //#endregion

      //#region UPDATE UI
      function updateUIAfterModelChange(parentItem) {
        groups[0].param = $(parentItem).find("label").text();
        $(parentItem)
          .closest(".interface__group")
          .find(".interface__group__head__param")
          .text(groups[0].param);

        radioModelInputs
          .find(".type_interface_radio-model_item")
          .removeClass(activeModelClass);

        parentItem.addClass(activeModelClass);
      }
      //#endregion

      //#region UPDATE POST
      function updatePostSize() {
        const postSizeOptions = $(".type_interface_post-size_item");
        const activeClass = "type_interface_post-size_item--active";
        const param = !state.model ? `8" x 8"` : `4" x 4"`;

        ChangeGlobalMorph("4-8", 0.5);

        postSizeOptions.eq(0).addClass(activeClass);
        postSizeOptions.eq(1).removeClass(activeClass);

        state.initValuePostSize = "6";
        postSizeOptions.eq(1).text(param);

        $(".interface__group")
          .find(".interface__group__head__param")
          .eq(5)
          .text('6" x 6"');

        if (!state.model) {
          $("#param-light").show();
        } else {
          $("#param-light").hide();
        }
      }
      //#endregion
      //#endregion

      return radioModelInputs;

    case typesInputs.mountedType:
      const selectWalls = $(`
                  <form class="type_interface_checkbox-wall type_interface_checkbox-wall--four-season">
                    <div class="wrapp-wall" id="wall-option">
                       <div class="type_interface_checkbox-wall_item option" id="back"> 
                      <div class="type_interface_checkbox-wall_item-img type_interface_checkbox-wall_item-img--back"></div>
    
                      <div class="type_interface_checkbox-wall_bottom">
                        <input class="type_interface_checkbox-wall_option" type="checkbox">
                        <label for="back">Back Wall</label>
                      </div> 
                    </div>
               
                    <div class="type_interface_checkbox-wall_item option" id="left"> 
                      <div class="type_interface_checkbox-wall_item-img type_interface_checkbox-wall_item-img--left"></div>
    
                      <div class="type_interface_checkbox-wall_bottom">
                        <input class="type_interface_checkbox-wall_option" type="checkbox">
                        <label for="left">Left Wall</label>
                      </div> 
                    </div>
                 
                    <div class="type_interface_checkbox-wall_item option" id="right"> 
                      <div class="type_interface_checkbox-wall_item-img type_interface_checkbox-wall_item-img--right"></div>
    
                      <div class="type_interface_checkbox-wall_bottom">
                        <input class="type_interface_checkbox-wall_option" type="checkbox">
                        <label for="right">Right Wall</label>
                      </div> 
                    </div>
                  </div>
                  </form>
                   `);

      const activeWallClass = "active";
      const activeAddWallOptionsClass = "type_interface_post-size_item--active";
      const backWall = selectWalls.find("#back");
      const leftWall = selectWalls.find("#left");
      const rightWall = selectWalls.find("#right");

      function toggleClass(item, settings) {
        if (settings) {
          item.addClass(activeWallClass);
        } else {
          item.removeClass(activeWallClass);
        }
      }

      // INIT BUTTONS WALL
      toggleBackWall(state.backWall);
      toggleLeftWall(state.leftWall);
      toggleRightWall(state.rightWall);

      updateTextParam(state, backWall, false, false, false, true);

      if (state.backWall) {
        toggleClass(backWall, state.backWall);
      }
      if (state.leftWall) {
        toggleClass(leftWall, state.leftWall);
      }
      if (state.rightWall) {
        toggleClass(rightWall, state.rightWall);
      }

      // HANDLE BUTTONS WALL
      backWall.on("click", function () {
        state.backWall = !state.backWall;
        removeFromUrlSystemBySide(pergolaConst.side.Back);

        pergola.update();

        toggleBackWall(state.backWall);
        toggleClass($(this), state.backWall);

        updateTextParam(state, backWall, false, false, false, true);

        pergola.checkSystemsInScene();

        // setAllHotspotsVisibility(false);
      });

      leftWall.on("click", function () {
        state.leftWall = !state.leftWall;
        removeFromUrlSystemBySide(pergolaConst.side.Left);

        pergola.update();

        toggleLeftWall(state.leftWall);
        toggleClass($(this), state.leftWall);

        updateTextParam(state, backWall, false, false, false, true);

        pergola.checkSystemsInScene();

        // setAllHotspotsVisibility(false);
      });

      rightWall.on("click", function () {
        state.rightWall = !state.rightWall;
        removeFromUrlSystemBySide(pergolaConst.side.Right);

        pergola.update();

        toggleRightWall(state.rightWall);
        toggleClass($(this), state.rightWall);

        updateTextParam(state, backWall, false, false, false, true);

        pergola.checkSystemsInScene();

        // setAllHotspotsVisibility(false);
      });

      return selectWalls;

    case typesInputs.range:
      let rangesResult = $(``);
      const currentRanges = getRangesFromState();

      currentRanges.forEach((range) => {
        rangesResult = rangesResult.add(generateRangeHTML(range));
      });

      return rangesResult;

    case typesInputs.colorsButton:
      function generateColorHTML(colors) {
        return colors
          .map(
            (color) => `
          <div class="type_interface_colors-buttons_item option" data-hex="${
            color.hex
          }">
            <label class="type_interface_colors-buttons_label">
              <div class="image-container" 
                ${
                  color.name === "WoodGrain"
                    ? `style="background-color: ${color.hex}; background-image: url(${color.image}); background-size: cover; background-position: center; background-repeat: no-repeat;"`
                    : `style="background-color: ${color.hex}"`
                }>
              </div>
              <span class="color-name">${color.name}</span>
              <input class="type_interface_colors-buttons_option" type="radio" id="${
                color.id
              }" name="fav_language" value="${color.value}">
            </label>
          </div>
        `
          )
          .join("");
      }

      // Function to bind color click handlers
      function bindColorHandlers() {
        const activeClass = "active";

        // FRAME COLOR HANDLERS - Bind to current frameColorContent OR global selector
        const frameSelector =
          title === "Frame Color" ? frameColorContent : $(".js-colors-frame");
        const roofSelector =
          title === "Roof Color" ? roofColorContent : $(".js-colors-roof");

        // Unbind existing handlers to prevent duplicates
        frameSelector.find(".option").off("change");
        roofSelector.find(".option").off("change");

        // FRAME COLOR HANDLERS:
        frameSelector.find(".option").on("change", function () {
          // console.log("FRAME COLOR CLICKED!"); // Debug log

          const $this = $(this);
          const hex = $(this).attr("data-hex");
          const $item = $this.closest(".type_interface_colors-buttons_item");
          const $imgContainer = $item.find(".image-container");

          const bgColor = $imgContainer.css("background-color");
          // const bgImage = $imgContainer.css("background-image");

          let backgroundColor = pergola.rgbToHex(bgColor);

          // Update state
          state.colorBody = backgroundColor;
          const nameOfColor = $this.find("input").val();
          state.selectedFrameColorName = nameOfColor;

          console.log("Frame Test:", nameOfColor);

          // Update UI
          frameSelector.find(".option").removeClass(activeClass);
          $item.addClass(activeClass);

          // Update header
          $this
            .closest(".interface__group")
            .find(".interface__group__head__param")
            .text(nameOfColor);

          // Update 3D material
          const headerLettice = GetMesh("header_weatherproof");

          updateMaterialMap(headerLettice, hex);

          pergola.update();
        });

        // ROOF COLOR HANDLERS:
        roofSelector.find(".option").on("change", function () {
          console.log("ROOF COLOR TEST");

          const $this = $(this);
          const hex = $(this).attr("data-hex");
          const $item = $this.closest(".type_interface_colors-buttons_item");
          const $imgContainer = $item.find(".image-container");

          const bgColor = $imgContainer.css("background-color");
          // const bgImage = $imgContainer.css("background-image");

          let backgroundColor = pergola.rgbToHex(bgColor);

          console.log(backgroundColor, "NEW BG ROOF");
          // Update state
          state.colorRoof = backgroundColor;
          const nameOfColor = $this.find("input").val();
          state.selectedRoofColorName = nameOfColor;

          console.log("Roof color changed to:", nameOfColor); // Debug log

          // Update UI
          roofSelector.find(".option").removeClass(activeClass);
          $item.addClass(activeClass);

          // Update header
          $this
            .closest(".interface__group")
            .find(".interface__group__head__param")
            .text(nameOfColor);

          // Update 3D materials
          const louver = GetMesh("louver_villa_X");

          updateMaterialMap(louver, hex);

          pergola.update();
        });
      }

      // Function to initialize color selections
      function initializeColorSelections() {
        const activeClass = "active";

        // frame color selection initialisation
        const frameSelector =
          title === "Frame Color" ? frameColorContent : $(".js-colors-frame");
        const roofSelector =
          title === "Roof Color" ? roofColorContent : $(".js-colors-roof");

        frameSelector.find(".option").each(function () {
          const $this = $(this);
          const nameOfColor = $this.find("input").val();

          if (nameOfColor === state.selectedFrameColorName) {
            const $item = $this.closest(".type_interface_colors-buttons_item");

            $item.trigger("change");
          }
        });

        // roof color selection initialisation
        roofSelector.find(".option").each(function () {
          const $this = $(this);
          const nameOfColor = $this.find("input").val();

          if (nameOfColor === state.selectedFrameColorName) {
            const $item = $this.closest(".type_interface_colors-buttons_item");

            $item.trigger("change");
          }
        });
      }

      // Function to update colors when user changes Pergola model
      function updateColorSections() {
        const updatedColorRoof = generateColorHTML(state.colorsRoof);
        const updatedColorFrame = generateColorHTML(state.colorsFrame);

        $(".js-colors-frame").html(updatedColorFrame);
        $(".js-colors-roof").html(updatedColorRoof);

        bindColorHandlers();

        // Initialize selections
        initializeColorSelections();
      }

      // Generate initial HTML
      const colorRoof = generateColorHTML(state.colorsRoof);
      const colorFrame = generateColorHTML(state.colorsFrame);

      const frameColorContent = $(`
    <form class="type_interface_colors-buttons" id="frame-color">
      <div class="colors_container js-colors-frame">
        ${colorFrame}
      </div>

      <div class="select-inputs"  style="display: flex; gap: 20px;">
              <div class="type_interface_checkbox-wall_item" id="gold-bar"  style="width: fit-content;"> 
                <div class="type_interface_checkbox-wall_bottom">
                  <input class="type_interface_checkbox-wall_option" type="checkbox">
                  <label style="white-space: nowrap;" for="back">Remove gold bar</label>
                </div> 
              </div>
           </div>
    </form>
  `);

      const roofColorContent = $(`
    <form class="type_interface_colors-buttons">
      <div id="lettice">
        <div class="colors_container js-colors-roof">            
          ${colorRoof}
        </div>
      </div>
    </form>
  `);

      const activeColorClass = "active";

      // INIT FRAME COLOR SECTION:
      if (title === "Frame Color") {
        const header = GetMesh("header_weatherproof");

        // #region INIT GOLDEN-BAR
        frameColorContent.find("#gold-bar").each(function () {
          if (state.goldBar) {
            $(this).addClass("active");
          }

          pergola.update();
        });
        //  #endregion

        //#region HANDLE GOLDEN-BAR
        frameColorContent.find("#gold-bar").on("click", function () {
          const $input = $(this);

          $input.toggleClass("active");

          state.goldBar = !state.goldBar;

          pergola.update();
        });
        //#endregion

        // INIT
        setTimeout(() => {
          frameColorContent.find(".option").each(function () {
            const $this = $(this);
            const hex = $(this).attr("data-hex");
            const $item = $this.closest(".type_interface_colors-buttons_item");
            const $imgContainer = $item.find(".image-container");

            const bgColor = $imgContainer.css("background-color");
            const bgImage = $imgContainer.css("background-image");
            const nameOfColor = $this.find("input").val();

            const extractPublicPath = (url) => {
              const match = url.match(/\/public\/.+$/);
              return match ? match[0] : url;
            };

            const backgroundColor = pergola.rgbToHex(bgColor);

            const normalizedStateColor = extractPublicPath(state.colorBody);

            if (normalizedStateColor === backgroundColor) {
              $item.addClass(activeColorClass);
              $this.prop("checked", true);

              state.colorBody = backgroundColor;
              state.selectedFrameColorName = nameOfColor;

              setTimeout(() => {
                $this
                  .closest(".interface__group")
                  .find(".interface__group__head__param")
                  .text(nameOfColor);

                updateMaterialMap(header, hex);
              }, 400);
            }

            pergola.update();
          });
        }, 2000);

        // HANDLE
        bindColorHandlers();
      }

      // INIT ROOF COLOR SECTION:
      if (title === "Roof Color") {
        const louver = GetMesh("louver_villa_X");
        const headerLettice = GetMesh("rafter_bevel_1");
        const beamLettice = GetMesh("beam");
        const backBeam = GetMesh("back_beam");
        const solid = GetMesh("wrap_kit");

        // INIT
        setTimeout(() => {
          roofColorContent.find(".option").each(function () {
            const $this = $(this);
            const hex = $(this).attr("data-hex");
            const $item = $this.closest(".type_interface_colors-buttons_item");
            const $imgContainer = $item.find(".image-container");

            const bgColor = $imgContainer.css("background-color");
            const bgImage = $imgContainer.css("background-image");
            const nameOfColor = $this.find("input").val();

            const extractPublicPath = (url) => {
              const match = url.match(/\/public\/.+$/);
              return match ? match[0] : url;
            };

            const backgroundColor = pergola.rgbToHex(bgColor);

            const normalizedStateColor = extractPublicPath(state.colorRoof);

            if (normalizedStateColor === backgroundColor) {
              $item.addClass(activeColorClass);
              $this.prop("checked", true);

              state.colorRoof = backgroundColor;
              state.selectedRoofColorName = nameOfColor;

              setTimeout(() => {
                $this
                  .closest(".interface__group")
                  .find(".interface__group__head__param")
                  .text(nameOfColor);

                updateMaterialMap(louver, hex);
                updateMaterialMap(headerLettice, hex);
                updateMaterialMap(beamLettice, hex);
                updateMaterialMap(backBeam, hex);
              }, 400);
            }

            pergola.update();
          });
        }, 2000);

        // HANDLE
        bindColorHandlers();
      }

      window.updateColorSections = updateColorSections;

      return title === "Roof Color" ? roofColorContent : frameColorContent;

    case typesInputs.subSystem:
      const subSystemContent = $(`
            <form class="type_interface_electronic" id="last-group">
              <div class="type_interface_electronic_item option" id="${pergolaConst.systemType.zip_shade}">
                <label class="type_interface_electronic_label">
                  <div class="image-container">
                    <img src="public/img/shades.png" alt="${pergolaConst.systemNameString.zip_shade}" class="color-image">
                  </div>
                  <span class="electronic-name">${pergolaConst.systemNameString.zip_shade}</span>
                  <input class="type_interface_electronic_option" type="radio" id="TexturedBlack" name="fav_language" value="${pergolaConst.systemNameString.zip_shade}">
                </label>
              </div>
        
              <div class="type_interface_electronic_item option" id="${pergolaConst.systemType.sliding_doors}">
                <label class="type_interface_electronic_label">
                  <div class="image-container">
                    <img src="public/img/glassDoors.png" alt="Sliding Glass Door" class="color-image">
                  </div>
                  <span class="electronic-name">Sliding Glass Door</span>
                  <input class="type_interface_electronic_option" type="radio" id="TexturedBlack" name="fav_language" value="${pergolaConst.systemNameString.sliding_doors}">
                </label>
              </div>
                
              <div class="type_interface_electronic_item option" id="${pergolaConst.systemType.sliding_shutters}">
                <label class="type_interface_electronic_label">
                  <div class="image-container">
                    <img src="public/img/shutters.png" alt="Sliding Shutters" class="color-image">
                  </div>
                  <span class="electronic-name">Sliding Shutters</span>
                  <input class="type_interface_electronic_option" type="radio" id="TexturedBlack" name="fav_language" value="${pergolaConst.systemNameString.sliding_shutters}">
                </label>
              </div>
        
              <div class="type_interface_electronic_item option" id="${pergolaConst.systemType.railing_frame}">
                <label class="type_interface_electronic_label">
                  <div class="image-container">
                    <img src="public/img/railing.png" alt="Fixed Slats" class="color-image">
                  </div>
                  <span class="electronic-name">Railing</span>
                  <input class="type_interface_electronic_option" type="radio" id="TexturedBlack" name="fav_language" value="${pergolaConst.systemNameString.railing_frame}">
                </label>
              </div>
            </form>
          `);

      const activeStyleSubSystem = "type_interface_electronic_item--active";
      const screenIcon = $("#screen");
      const shadesIcon = $("#shades");
      const portalScreen = $(".portal-screen");
      const portalShades = $(".portal-shades");
      const closeButtonScreen = $(".portal-screen__close");
      const closeButtonShades = $(".portal-shades__close");

      //#region INIT INPUT
      subSystemContent.find('input[type="radio"]').each(function () {
        const $currentInput = $(this);

        const inputValue = $currentInput.val();

        switch (inputValue) {
          case pergolaConst.systemNameString.zip_shade:
            state.currentActiveSystems = pergolaConst.systemType.zip_shade;

            break;

          case pergolaConst.systemNameString.sliding_doors:
            state.currentActiveSystems = pergolaConst.systemType.sliding_doors;

            break;

          case pergolaConst.systemNameString.sliding_shutters:
            state.currentActiveSystems =
              pergolaConst.systemType.sliding_shutters;

            break;

          case pergolaConst.systemNameString.railing_frame:
            state.currentActiveSystems = pergolaConst.systemType.railing_frame;
            break;
        }

        if (state.subSystem.has(inputValue)) {
          $currentInput.prop("checked", true);
          $currentInput
            .closest(".type_interface_electronic_item")
            .addClass(activeStyleSubSystem);

          $currentInput.trigger("click");
          showIcon(state.currentActiveSystems);

          pergola.update();
        }

        $(this)
          .closest(".interface__group")
          .find(".interface__group__head__param")
          .text(`${updateTextParam(state, this, false, true, true, false)}`);
      });
      //#endregion

      //#region HANDLE INPUTS
      subSystemContent.find('input[type="radio"]').on("click", function () {
        const $currentInput = $(this);
        const inputValue = $currentInput.val();

        setAllHotspotsVisibility(true);
        pergola.update();

        switch (inputValue) {
          case pergolaConst.systemNameString.zip_shade:
            state.currentActiveSystems = pergolaConst.systemType.zip_shade;

            break;

          case pergolaConst.systemNameString.sliding_doors:
            state.currentActiveSystems = pergolaConst.systemType.sliding_doors;

            break;

          case pergolaConst.systemNameString.sliding_shutters:
            state.currentActiveSystems =
              pergolaConst.systemType.sliding_shutters;

            break;

          case pergolaConst.systemNameString.railing_frame:
            state.currentActiveSystems = pergolaConst.systemType.railing_frame;
            break;
        }

        if (state.subSystem.has(inputValue)) {
          state.subSystem.delete(inputValue);
          $currentInput.prop("checked", false);
          $currentInput
            .closest(".type_interface_electronic_item")
            .removeClass(activeStyleSubSystem);

          pergola.removeSystemFromSpanType(state.currentActiveSystems);
          removeFromUrlSystemByType(state.currentActiveSystems);
          hideIcon(state.currentActiveSystems);

          state.currentActiveSystems = null;

          pergola.update();
        } else {
          state.subSystem.add(inputValue);
          $currentInput.prop("checked", true);
          $currentInput
            .closest(".type_interface_electronic_item")
            .addClass(activeStyleSubSystem);

          showIcon(state.currentActiveSystems);

          pergola.update();
        }

        $(this)
          .closest(".interface__group")
          .find(".interface__group__head__param")
          .text(`${updateTextParam(state, this, false, true, true, false)}`);
      });
      //#endregion

      return subSystemContent;

    case typesInputs.electronic:
      const electronicContent = $(`
    <form class="type_interface_electronic" id="electro-group" data-group="electronic">
      <div class="type_interface_electronic_item option" id="electronic-led-${pergolaConst.option.LEDRampLight}">
        <label class="type_interface_electronic_label">
          <div class="image-container">
            <img src="public/img/electro/LEDRampLight.svg" alt="${pergolaConst.optionNameString.LEDRampLight}" class="electronic-image">
          </div>
          <span class="electronic-name">${pergolaConst.optionNameString.LEDRampLight}</span>
          <input class="type_interface_electronic_option" type="radio" id="input-led-${pergolaConst.option.LEDRampLight}" name="electronic_options" value="${pergolaConst.optionNameString.LEDRampLight}">
        </label>
      </div>

      <div class="type_interface_electronic_item option" id="electronic-fan-${pergolaConst.option.fans}">
        <label class="type_interface_electronic_label">
          <div class="image-container">
            <img src="public/img/electro/fans.svg" alt="${pergolaConst.optionNameString.fans}" class="electronic-image">
          </div>
          <span class="electronic-name">${pergolaConst.optionNameString.fans}</span>
          <input class="type_interface_electronic_option" type="radio" id="input-fan-${pergolaConst.option.fans}" name="electronic_options" value="${pergolaConst.optionNameString.fans}">
        </label>
      </div>

      <div class="type_interface_electronic_item option" id="electronic-heater-${pergolaConst.option.heaters}">
        <label class="type_interface_electronic_label">
          <div class="image-container">
            <img src="public/img/electro/heaters.svg" alt="${pergolaConst.optionNameString.heaters}" class="electronic-image">
          </div>
          <span class="electronic-name">${pergolaConst.optionNameString.heaters}</span>
          <input class="type_interface_electronic_option" type="radio" id="input-heater-${pergolaConst.option.heaters}" name="electronic_options" value="${pergolaConst.optionNameString.heaters}">
        </label>
      </div>

      <div class="type_interface_electronic_item option ledLouvers_item" id="electronic-louver-${pergolaConst.option.ledLouvers}">
        <label class="type_interface_electronic_label">
          <div class="image-container">
            <img src="public/img/electro/ledLouvers.svg" alt="${pergolaConst.optionNameString.ledLouvers}" class="electronic-image">
          </div>
          <span class="electronic-name">${pergolaConst.optionNameString.ledLouvers}</span>
          <input class="type_interface_electronic_option" type="radio" id="input-louver-${pergolaConst.option.ledLouvers}" name="electronic_options" value="${pergolaConst.optionNameString.ledLouvers}">
        </label>
      </div>
    </form>
  `);

      const activeElectronicStyle = "type_interface_electronic_item--active";

      function handleInputChange($input, init = false) {
        const inputValue = $input.val();

        // console.log("ELECTRONIC SECTION DEBUGGING Input value:", inputValue);

        // Update state.currentActiveSystems before calling pergola.update()
        // switch (inputValue) {
        //   case pergolaConst.optionNameString.fans: // "Fan"
        //     state.currentActiveSystems = pergolaConst.option.fans; // 10
        //     console.log("Set fans to:", state.currentActiveSystems);
        //     break;

        //   case pergolaConst.optionNameString.LEDRampLight: // "LED lights"
        //     state.currentActiveSystems = pergolaConst.option.LEDRampLight; //  11
        //     console.log("Set LED lights to:", state.currentActiveSystems);
        //     break;

        //   case pergolaConst.optionNameString.heaters: // "Heaters"
        //     state.currentActiveSystems = pergolaConst.option.heaters; //  44
        //     console.log("Set heaters to:", state.currentActiveSystems);
        //     break;

        //   case pergolaConst.optionNameString.ledLouvers: // "LED lights on louvers"
        //     state.currentActiveSystems = pergolaConst.option.ledLouvers; // 55
        //     console.log("Set LED louvers to:", state.currentActiveSystems);
        //     break;

        //   default:
        //     console.log("No match found for:", inputValue);
        //     state.currentActiveSystems = null;
        //     break;
        // }

        // Only call setAllHotspotsVisibility for heaters
        if (inputValue === pergolaConst.optionNameString.heaters) {
          setAllHotspotsVisibility(true);
          // updateIconVisibility();
        }

        // pergola.update();

        const isElectroOption = [
          pergolaConst.optionNameString.LEDRampLight,
          pergolaConst.optionNameString.fans,
          pergolaConst.optionNameString.heaters,
          pergolaConst.optionNameString.ledLouvers,
        ].includes(inputValue);

        const activateInput = ($input) => {
          $input.prop("checked", true);
          $input
            .closest(".type_interface_electronic_item")
            .addClass(activeElectronicStyle);
        };

        const deactivateInput = ($input) => {
          $input.prop("checked", false);
          $input
            .closest(".type_interface_electronic_item")
            .removeClass(activeElectronicStyle);
        };

        const handleElectroOption = () => {
          if (state.electro.has(inputValue) && !init) {
            if (state.electro.has(pergolaConst.optionNameString.heaters)) {
              pergola.removeHeaters();
            }

            // Deselecting an option
            state.electro.delete(inputValue);
            deactivateInput($input);

            // Hide the icon for this system
            if (typeof hideIcon === "function" && state.currentActiveSystems) {
              hideIcon(state.currentActiveSystems);
            }

            // Reset portal and active system if this was the active one
            state.portalOption = null;
            state.currentActiveSystems = null;
            state.activeHotspotHeater = null;

            // Hide hotspots if this was heaters
          } else {
            // Selecting an option
            state.electro.add(inputValue);
            activateInput($input);

            state.activeHotspotHeater = state.electro.has(
              pergolaConst.optionNameString.heaters
            );

            // Set this as the active portal option
            state.portalOption = state.currentActiveSystems;
          }
        };

        if (isElectroOption) {
          handleElectroOption();
        }

        // Update pergola after all state changes
        pergola.update();
        // Show the icon for this system
        if (state.electro.has(pergolaConst.optionNameString.heaters)) {
          showIcon(6);
        } else {
          hideIcon(6);
        }

        // Update the interface text - FIX: Use only electro, not both electro and subSystem
        const electroText = Array.from(state.electro).join(", ") || "-";
        $input
          .closest(".interface__group")
          .find(".interface__group__head__param")
          .html(`<span class="param-text">${electroText}</span>`);
      }

      //#region INIT INPUT
      electronicContent.find('input[type="radio"]').each(function () {
        const $input = $(this);
        const inputValue = $input.val();

        if (state.electro.has(inputValue)) {
          handleInputChange($input, true);
        }

        state.activeHotspotHeater = null;
      });
      //#endregion

      //#region HANDLE INPUTS
      electronicContent.find('input[type="radio"]').on("click", function () {
        handleInputChange($(this));
      });

      setTimeout(() => {
        updateInterfaceHeaderText();
      }, 100);
      //#endregion

      return electronicContent;

    // Code from Kool covers four season, without which - roof is not working correctly
    case typesInputs.roofType:
      const radioRoofTypeContent = $(`
            <form class="type_interface_radio-model">
              <div class="type_interface_radio-model_item option" id="lattice-roof">
                <input data-value="0" class="type_interface_radio-model_option type_interface_radio-model_option--lattice"
                    type="radio" id="shade" name="fav_language" value="${stringRoofType[0]}"
                    style="height: 90px"
                    >
                <label class="type_interface_radio-model_label" for="shade">${stringRoofType[0]}</label>
              </div>

              <div class="type_interface_radio-model_item option" id="solid-roof">
                <input data-value="1" class="type_interface_radio-model_option type_interface_radio-model_option--solid"
                    type="radio" id="blade" name="fav_language" value="${stringRoofType[1]}"
                    style="height: 90px"
                    >
                <label class="type_interface_radio-model_label" for="blade">${stringRoofType[1]}</label>
              </div>

              <div class="type_interface_radio-model_item option" id="combo-roof">
                <input data-value="2" class="type_interface_radio-model_option type_interface_radio-model_option--combo"
                    type="radio" id="blade" name="fav_language" value="${stringRoofType[2]}"
                    style="height: 90px"
                    >
                <label class="type_interface_radio-model_label" for="blade">${stringRoofType[2]}</label>
              </div>
            </form>`);

      const activeRoofTypeClass = "active";

      //INIT ROOF
      radioRoofTypeContent
        .find('.type_interface_radio-model_item input[type="radio"]')
        .each(function () {
          const radioButton = $(this);
          const type = +$(this).attr("data-value");
          const typeLattice = state.roofType === 0;
          const typeSolid = state.roofType === 1;
          const typeCombo = state.roofType === 2;

          hideIcon(10);
          hideIcon(11);
          hideIcon(12);

          $("#solid").show();

          if (typeLattice) {
            showIcon(11);
            state.beamSize = 1;
          }

          if (typeSolid) {
            showIcon(10);
            state.rain = false;
            state.directionRoof = false;
          }

          if (typeCombo) {
            showIcon(12);
            state.rain = false;
            state.directionRoof = false;
            state.beamSize = 1;
          }

          if (state.roofType === type) {
            radioButton
              .closest(".type_interface_radio-model_item")
              .addClass(activeRoofTypeClass);
          }

          setTimeout(() => {
            if (typeLattice) {
              $("#solid").hide();
            }
            if (typeSolid) {
              $("#lettice").hide();
            }
          }, 0);
        });

      //#region HANDLE ROOF
      radioRoofTypeContent
        .find('.type_interface_radio-model_item input[type="radio"]')
        .on("change", function () {
          // CHANGE STATE
          state.roofType = +$(this).attr("data-value");

          const typeLattice = state.roofType === 0;
          const typeSolid = state.roofType === 1;
          const typeCombo = state.roofType === 2;

          // state.colorBody = "#998F7A";
          // state.colorRoof = "#998F7A";
          // state.colorRoofSolid = "#998F7A";

          // stringNameRoofLetticeColor = "Adobe";
          // stringNameRoofSolidColor = "Adobe";
          // stringNameFrameColor = "Adobe";

          $("#wrap-kit").removeClass("active");
          state.wrapKit = false;

          $("#tails").removeClass("active");
          state.tails = false;
          state.directionRoof = false;

          hideIcon(10);
          hideIcon(11);
          hideIcon(12);

          $("#solid").show();
          $("#lettice").show();

          if (typeLattice) {
            showIcon(11);
            state.thickness = 0;
            state.beamSize = 1;

            $("#solid").hide();
            // $("#lettice .option")
            //   .eq($("#lettice .option").length - 1)
            //   .trigger("change");
            window.colorLattice();
          }

          if (typeSolid) {
            showIcon(10);
            $("#lettice").hide();
            $("#end-cuts .option")
              .removeClass("active")
              .eq(0)
              .addClass("active");

            $("#end-cuts .option")
              .eq(0)
              .closest(".interface__group")
              .find(".interface__group__head__param")
              .text($("#end-cuts .option").eq(0).find("input").val());

            state.endCuts = 1;
            state.thickness = 3;
            state.rain = false;
            // $("#solid .option").eq(0).trigger("change");

            window.colorSolidInit(false);
          }

          if (typeCombo) {
            showIcon(12);
            state.thickness = 0;
            state.beamSize = 1;

            ChangeGlobalMorph("3-6", 1.65);

            state.rain = false;
          }

          // #region RE-INIT thickness
          $(".portal-container")
            .find("#thickness .radio__container__item ")
            .each(function () {
              const $input = $(this);
              const id = +$(this).attr("id");

              //LOGIC FOR SOLID
              if (state.roofType === 1) {
                switch (true) {
                  case id === 3 && state.length > 16 && state.length <= 20:
                    $input.addClass("disable");

                    state.thickness =
                      state.thickness === 3 ? 4 : state.thickness;
                    break;

                  case id === 3 && 20 < state.length:
                  case id === 4 && 20 < state.length:
                    $input.addClass("disable");
                    state.thickness = 6;
                    break;
                }
              }

              if (id === state.thickness) {
                $input.addClass("active");
              }
            });

          // #endregion

          const parentItem = $(this).closest(
            ".type_interface_radio-model_item"
          );

          radioRoofTypeContent
            .find(".type_interface_radio-model_item")
            .removeClass(activeRoofTypeClass);

          parentItem.addClass(activeRoofTypeClass);

          $(parentItem)
            .closest(".interface__group")
            .find(".interface__group__head__param")
            .text($(this).val());

          // updatePostSize();

          $("#solid .option").eq(0).trigger("change");
          state.colorRoofSolid = $("#solid .option").eq(0).attr("data-hex");
          $("#lettice .option").eq(0).trigger("change");
          state.colorRoof = $("#lettice .option").eq(0).attr("data-hex");

          pergola.update();
        });
      //#endregion

      return radioRoofTypeContent;

    case typesInputs.typePergola:
      const typePergolaContent = $(`
      <form class="type_interface_post-size" style="flex-direction: row;">
          <div class="type_interface_post-size_item option">
              <input class="type_interface_post-size_option" type="radio" id="0" name="fav_language" value="${stringTypePegola[0]}">
              <label for="0">${stringTypePegola[0]}</label>
          </div>

          <div class="type_interface_post-size_item option">
              <input class="type_interface_post-size_option" type="radio" id="1" name="fav_language" value="${stringTypePegola[1]}">
              <label for="1">${stringTypePegola[1]}</label>
         </div>
      </form>
  `);

      const activeClassTypePergola = "active";

      // //INIT INPUT
      typePergolaContent
        .find(".type_interface_post-size_item")
        .each(function () {
          $(this).removeClass(activeClassTypePergola);

          pergola.changeWallMaterials();

          if (state.typePergola === +$(this).find("input").attr("id")) {
            $(this).addClass(activeClassTypePergola);
          }
        });

      //HANDLE INPUT
      typePergolaContent
        .find(".type_interface_post-size_item")
        .on("click", function () {
          typePergolaContent
            .find(".type_interface_post-size_item")
            .removeClass(activeClassTypePergola);

          const paramLabel = $(this).find("input").val();
          state.typePergola = +$(this).find("input").attr("id");

          pergola.changeWallMaterials();

          $(this).addClass(activeClassTypePergola);

          const $groupHeadParam = $(this)
            .closest(".interface__group")
            .find(".interface__group__head__param");

          $groupHeadParam.text(paramLabel);
          pergola.update();

          // toggleBackWall(state.backWall);
          // toggleLeftWall(state.leftWall);
          // toggleRightWall(state.rightWall);

          // updatePostSizeParams.call(this, selectedIndex);
        });

      return typePergolaContent;

    case typesInputs.postSize:
      const postSizeContent = $(`
          <form class="type_interface_post-size">
          <div class="wrapp_post-type">
              <div class="type_interface_radio-model_item option" id="0">
                <input data-value="0" class="type_interface_radio-model_option type_interface_post-size_option--standart"
                    type="radio" id="shade" name="fav_language" value="${stringPostType[0]}"
                    style="height: 90px"
                    >
                <label class="type_interface_radio-model_label" for="shade">${stringPostType[0]}</label>
              </div>

              <div class="type_interface_radio-model_item option" id="1">
                <input data-value="1" class="type_interface_radio-model_option type_interface_post-size_option--square"
                    type="radio" id="blade" name="fav_language" value="${stringPostType[1]}"
                    style="height: 90px"
                    >
                <label class="type_interface_radio-model_label" for="blade">${stringPostType[1]}</label>
              </div>

              <div class="type_interface_radio-model_item option" id="2">
                <input data-value="1" class="type_interface_radio-model_option type_interface_post-size_option--round"
                    type="radio" id="blade" name="fav_language" value="${stringPostType[2]}"
                    style="height: 90px"
                    >
                <label class="type_interface_radio-model_label" for="blade">${stringPostType[2]}</label>
              </div>
          </div>

          <div class="wrapp_post-add">
            <div class="radio-inputs">
             <div class="main_container" style="margin: 0" id="slats_radio">
              <div class="canvas_menu__title">Size</div>

              <ul class="radio__container">
                <li class="radio__container__item" id="8">
                  <div class="radio__container__item__cyrcle"></div>

                  <span class="radio__container__item__text">8"</span>
                 </li>

                 <li class="radio__container__item" id="10">
                   <div class="radio__container__item__cyrcle"></div>

                   <span class="radio__container__item__text" >10"</span>
                </li>

                 <li class="radio__container__item" id="12">
                   <div class="radio__container__item__cyrcle"></div>

                   <span class="radio__container__item__text">12"</span>
                </li>
              </ul>
             </div>
            </div>

            <div class="select-inputs">
             <div class="type_interface_checkbox-wall_item option" id="double-header">
                <div class="type_interface_checkbox-wall_bottom">
                  <input class="type_interface_checkbox-wall_option" type="checkbox">
                  <label for="back">Double Header</label>
                </div>
              </div>
            </div>
          </div>

          </form>
      `);

      const activeClass = "active";

      // INIT POST TYPE INPUT
      postSizeContent.find(".wrapp_post-type .option").each(function () {
        if (state.postType === +$(this).attr("id")) {
          $(this).addClass(activeClass);
          postSizeContent.find(".radio-inputs").hide();

          if (state.postType) {
            state.beam = true;
            postSizeContent.find("#double-header").addClass("active");
            postSizeContent.find("#double-header").addClass("disable-radio");
            postSizeContent.find(".radio-inputs").show();
          }

          setTimeout(() => {
            const paramLabel = $(this).find("input").val();

            const $groupHeadParam = $(this)
              .closest(".interface__group")
              .find(".interface__group__head__param");

            $groupHeadParam.text(paramLabel);
          }, 0);
        }
      });

      //INIT POST SIZE
      postSizeContent.find(".radio__container__item").each(function () {
        if (state.postSize === +$(this).attr("id")) {
          $(this).addClass(activeClass);
        }
      });

      //INIT DOUBLE HEADER
      postSizeContent.find("#double-header").each(function () {
        if (state.beam) {
          $(this).addClass(activeClass);
        }
      });

      //HANDLE POST TYPE
      postSizeContent.find(".wrapp_post-type .option").on("click", function () {
        postSizeContent
          .find(".wrapp_post-type .option")
          .removeClass(activeClass);

        const paramLabel = $(this).find("input").val();
        state.postType = +$(this).attr("id");

        //CHANGE BEAM DEPENDENCE TYPE
        state.beam = false;
        postSizeContent.find("#double-header").removeClass("active");
        postSizeContent.find("#double-header").removeClass("disable-radio");
        postSizeContent.find(".radio-inputs").hide();

        if (state.postType) {
          state.beam = true;
          postSizeContent.find("#double-header").addClass("active");
          postSizeContent.find("#double-header").addClass("disable-radio");
          postSizeContent.find(".radio-inputs").show();
        }

        $(this).addClass(activeClass);

        const $groupHeadParam = $(this)
          .closest(".interface__group")
          .find(".interface__group__head__param");

        $groupHeadParam.text(paramLabel);

        pergola.update();
      });

      //HANDLE POST SIZE
      postSizeContent.find(".radio__container__item").on("click", function () {
        postSizeContent
          .find(".radio__container__item")
          .removeClass(activeClass);

        state.postSize = +$(this).attr("id");

        $(this).addClass(activeClass);

        pergola.update();
      });

      //HANDLE DOUBLE HEADER
      postSizeContent.find("#double-header").on("click", function () {
        $(this).toggleClass(activeClass);
        state.beam = !state.beam;

        pergola.update();
      });

      return postSizeContent;

    case typesInputs.endCuts:
      const endCutsContent = $(`
              <form class="type_interface_radio-model" id="end-cuts">
                <div class="type_interface_radio-model_item option" id="1">
                  <input data-value="0" class="type_interface_radio-model_option ends-cut--bevel"
                      type="radio" name="fav_language" value="${stringEndCuts[0]}"
                      style="height: 80px"
                      >
                  <label class="type_interface_radio-model_label" for="shade">${stringEndCuts[0]}</label>
                </div>

                <div class="type_interface_radio-model_item option" id="2">
                  <input data-value="1" class="type_interface_radio-model_option ends-cut--mitre"
                      type="radio" name="fav_language" value="${stringEndCuts[1]}"
                      style="height: 80px"
                      >
                  <label class="type_interface_radio-model_label" for="blade">${stringEndCuts[1]}</label>
                </div>

                <div class="type_interface_radio-model_item option" id="3">
                  <input data-value="1" class="type_interface_radio-model_option ends-cut--corbel"
                      type="radio" name="fav_language" value="${stringEndCuts[2]}"
                      style="height: 80px"
                      >
                  <label class="type_interface_radio-model_label" for="blade">${stringEndCuts[2]}</label>
                </div>

                <div class="type_interface_radio-model_item option" id="4">
                  <input data-value="1" class="type_interface_radio-model_option ends-cut--scallop"
                      type="radio" name="fav_language" value="${stringEndCuts[3]}"
                      style="height: 80px"
                      >
                  <label class="type_interface_radio-model_label" for="blade">${stringEndCuts[3]}</label>
                </div>
              </form>`);

      // //INIT MODEL
      endCutsContent.find(".option").each(function () {
        const id = +$(this).attr("id");

        if (id === state.endCuts) {
          $(this).addClass("active");

          setTimeout(() => {
            $(this)
              .closest(".interface__group")
              .find(".interface__group__head__param")
              .text($(this).find("input").val());
          }, 0);
        }
      });

      //#region HANDLE MODEL
      endCutsContent.find(".option").on("click", function () {
        const parentItem = $(this).closest(".type_interface_radio-model_item");
        const id = +$(this).attr("id");

        state.endCuts = id;

        endCutsContent.find(".option").removeClass("active");

        parentItem.addClass("active");

        $(parentItem)
          .closest(".interface__group")
          .find(".interface__group__head__param")
          .text($(this).find("input").val());

        pergola.update();
      });
      //#endregion

      return endCutsContent;

    case typesInputs.roofForLite:
      const roofContent = $(`
            <form class="type_interface_electronic">
              <div class="type_interface_electronic_item option">
                <label class="type_interface_electronic_label">
                   <div class="image-container">
                       <img src="public/img/sletted.png" alt="Screens" class="color-image">
                   </div>

                   <span class="electronic-name">Slatted</span>
                   <input class="type_interface_electronic_option" type="radio" id="TexturedBlack" name="fav_language" value="Slatted">
                </label>
              </div>

              <div class="type_interface_electronic_item option">
                <label class="type_interface_electronic_label">
                   <div class="image-container">
                       <img src="public/img/screen-roof.png" alt="Textured Gray" class="color-image">
                   </div>

                   <span class="electronic-name">Screens</span>
                   <input class="type_interface_electronic_option" type="radio" id="TexturedBlack" name="fav_language" value="Screens">
                </label>
              </div>
            </form>
            `);

      const activeStyleRoof = "type_interface_electronic_item--active";

      // INIT INPUT
      roofContent.find('input[type="radio"]').each(function () {
        const inputValue = $(this).val();

        if (state.moodLight === inputValue) {
          $(this)
            .closest(".type_interface_electronic_item")
            .addClass(activeStyleRoof);
          $(this).prop("checked", true);
        }
      });

      // HANDLE INPUTS
      roofContent.find('input[type="radio"]').on("click", function () {
        const inputValue = $(this).val();
        state.moodLight = inputValue;

        // CURRENT OPTION
        $(this).prop("checked", true);
        $(this)
          .closest(".type_interface_electronic_item")
          .addClass(activeStyleRoof);

        // ALL OPTION
        $(this)
          .closest(".type_interface_electronic")
          .find(".type_interface_electronic_item")
          .not($(this).closest(".type_interface_electronic_item"))
          .removeClass(activeStyleRoof);

        // UPDATE TEXT
        $(this)
          .closest(".interface__group")
          .find(".interface__group__head__param")
          .text(`${state.moodLight}`);

        pergola.update();
      });

      //#region SCREEN BUTTON HANDLE
      roofContent
        .find(".type_interface_electronic_item")
        .eq(1)
        .on("click", () => {
          const roofTypes = $(".interface__group").eq(3);

          roofTypes.show();
          pergola.update();
        });
      //#endregion

      //#region SLATTED HANDLE
      roofContent
        .find(".type_interface_electronic_item")
        .eq(0)
        .on("click", () => {
          const roofTypes = $(".interface__group").eq(3);

          roofTypes.hide();
          pergola.update();
        });
      //#endregion

      return roofContent;

    default:
      return `< div > NON HTML</div > `;
  }
}
